import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import { App } from '@/app/App'
import { initI18n } from '@/shared/i18n'
import { initSentry } from '@/shared/observability/sentry'
import { initTheme } from '@/shared/theme'

import './styles/index.css'

// Before render, so an error during the first paint is still captured.
initSentry()

// Light unless the user chose dark (owner ruling, 1 October 2026). Usually a
// repeat of what `public/theme-boot.js` already did in <head> — this is the
// backstop if that file failed to load, and the one place the theme module
// takes over from it.
initTheme()

const container = document.getElementById('root')
if (!container) throw new Error('Root element #root is missing from index.html')

// i18n resolves before the first render so nothing paints in the wrong language
// and then flips — which in Arabic would also be a direction flip.
void initI18n().then(() => {
  createRoot(container).render(
    <StrictMode>
      <App />
    </StrictMode>,
  )
})
